import { ROLES } from '../constants/global';
import { ValidateMultimedia } from './utilities.type';

export const minimunValidationForMultimedia = ({
	roles,
	shared = false,
	isImpersonating,
}: ValidateMultimedia): boolean => !isImpersonating && !shared && roles.includes(ROLES.VIDEO_CAMERA);

export const capitilizeFirstLetter = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
